<script setup>
/**
 * The session panel's section icons, as the prototype's rail draws them (its
 * SECTIONS: Chat ic.mail, Q&A ic.qbubble, Polls ic.chart, Rooms ic.repeat, Files
 * ic.file, People ic.users) — one stroke, the current colour.
 */
const props = defineProps({
  /** chat · qa · polls · rooms · files · people */
  name: { type: String, required: true },
  size: { type: Number, default: 19 },
});

const SHAPES = {
  chat: [['rect', { x: 3.5, y: 5.5, width: 17, height: 13, rx: 2.5 }], ['path', { d: 'm4.6 8 7.4 5 7.4-5' }]],
  // The question bubble (prototype ic.qbubble, cd198): the hand means "I want
  // to speak", and one picture can't mean both.
  qa: [['path', { d: 'M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.9-.9L3 21l1.9-4.6A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5Z' }], ['path', { d: 'M10.1 9.2a2 2 0 0 1 3.9.6c0 1.3-2 1.7-2 3' }], ['path', { d: 'M12 15.2h.01' }]],
  polls: [['path', { d: 'M4.2 19.8h15.6' }], ['path', { d: 'M7.6 19.8v-6M12 19.8V7.2M16.4 19.8v-9' }]],
  rooms: [['path', { d: 'M5 11V9a2.5 2.5 0 0 1 2.5-2.5h11' }], ['path', { d: 'm15.6 3.6 3 3-3 3' }], ['path', { d: 'M19 13v2a2.5 2.5 0 0 1-2.5 2.5h-11' }], ['path', { d: 'm8.4 20.4-3-3 3-3' }]],
  files: [['path', { d: 'M13.6 4H7.5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V9z' }], ['path', { d: 'M13.6 4v5h4.9' }]],
  people: [['circle', { cx: 9, cy: 8, r: 3.2 }], ['path', { d: 'M3.6 20v-1.4A4 4 0 0 1 7.6 14.6h2.8a4 4 0 0 1 4 4V20' }], ['circle', { cx: 17.4, cy: 9, r: 2.4 }], ['path', { d: 'M16 14.7h1.8a3 3 0 0 1 3 3V20' }]],
};

// The prototype's optical compensation (J): smaller icons get a heavier line.
const strokeWidth = (size) => (size < 13 ? 2.1 : size < 17 ? 1.9 : 1.7);
</script>

<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth(props.size)"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <component :is="tag" v-for="([tag, attrs], i) in SHAPES[props.name] ?? []" :key="i" v-bind="attrs" />
  </svg>
</template>
